
export const REQUEST_GETVIDEOTAG= 'REQUEST_GETVIDEOTAG';
export const GETVIDEOTAG_RECEIVED = 'GETVIDEOTAG_RECEIVED';